(() => {
  if (customElements.get("a-tab-cards")) return;

  class ATabCards extends HTMLElement {
    connectedCallback() {
      this.tabButtons = Array.from(this.querySelectorAll("[data-tab-target]"));
      this.cards = Array.from(this.querySelectorAll(".a-tab-cards__card[data-tab-key]"));
      this.viewAllWrap = this.querySelector(".a-tab-cards__view-all-wrap");
      this.viewAllLink = this.querySelector(".a-tab-cards__view-all");

      if (!this.tabButtons.length || !this.cards.length) return;

      this.defaultTab = this.dataset.defaultTab || this.tabButtons[0].dataset.tabTarget;
      this.boundClick = this.handleTabClick.bind(this);
      this.tabButtons.forEach((button) => {
        button.addEventListener("click", this.boundClick);
      });

      const activeButton = this.tabButtons.find((button) => button.getAttribute("aria-selected") === "true");
      const initialTab = activeButton?.dataset.tabTarget || this.defaultTab;
      this.setActiveTab(initialTab);
    }

    disconnectedCallback() {
      if (!this.tabButtons || !this.boundClick) return;
      this.tabButtons.forEach((button) => {
        button.removeEventListener("click", this.boundClick);
      });
    }

    handleTabClick(event) {
      const target = event.currentTarget?.dataset?.tabTarget;
      if (!target) return;
      this.setActiveTab(target);
    }

    setActiveTab(tabKey) {
      let activeButton = null;
      this.tabButtons.forEach((button) => {
        const isActive = button.dataset.tabTarget === tabKey;
        button.setAttribute("aria-selected", isActive ? "true" : "false");
        if (isActive) activeButton = button;
      });

      this.cards.forEach((card) => {
        const isMatch = card.dataset.tabKey === tabKey;
        card.hidden = !isMatch;
      });

      this.updateViewAll(activeButton);
    }

    updateViewAll(activeButton) {
      if (!this.viewAllWrap || !this.viewAllLink) return;
      const text = activeButton?.dataset?.viewAllText?.trim() || "";
      const link = activeButton?.dataset?.viewAllLink?.trim() || "#";

      if (!text) {
        this.viewAllWrap.hidden = true;
        this.viewAllLink.textContent = "";
        this.viewAllLink.setAttribute("href", "#");
        return;
      }

      this.viewAllWrap.hidden = false;
      this.viewAllLink.textContent = text;
      this.viewAllLink.setAttribute("href", link || "#");
    }
  }

  customElements.define("a-tab-cards", ATabCards);
})();
